import React from 'react';

import type {FrqRubric} from 'lib/rubric/types';

import FrqEvaluationSummary from './FrqEvaluationSummary.react';

import type {ManualEvaluation} from './FrqEvaluationSummary.types';

type Props = {
  /** Criteria rubric to break down; null omits the criterion list (unstructured rubrics). */
  rubric: FrqRubric | null;
  evaluation: ManualEvaluation;
  /** Rendered above the criterion list, inset to match it — the correctness banner. */
  banner?: React.ReactNode;
  /** Teacher-only; see `FrqEvaluationSummary`. Absent on the student's own view. */
  onAddGrade?: (criterionId: string) => void;
};

/**
 * A graded evaluation rendered read-only. The single presentation shared by the student's released
 * grade and the teacher's preview of it, so the two can't drift apart — a teacher previewing
 * before release is looking at the same component the student will get.
 *
 * Holds the outer x1 inset; each criterion adds x2 of its own, so content lands at 24px while the
 * divider between criteria — a sibling of those blocks, with no padding — stops at the x1 edge.
 */
export default function GradedEvaluationBody({rubric, evaluation, banner, onAddGrade}: Props) {
  return (
    <div className='gap-x2 background-primary px-x1 py-x1-half flex flex-col'>
      {banner ? <div className='px-x2'>{banner}</div> : null}
      <FrqEvaluationSummary rubric={rubric} evaluation={evaluation} onAddGrade={onAddGrade} />
    </div>
  );
}
